module.exports = __webpack_public_path__ + "static/media/Loader.4bba4bac.svg";